import React, { useState } from 'react';

import OrganisationEventsTable from './OrganisationEventsTable';

import { useToast } from 'Hooks/useToast';

export default function OrganisationEvents(props) {
    const [events, setEvents] = useState([]);

    const toast = useToast();

    const fetchEvents = async (perPage, page, sortBy, order, search) => {
        try {
            const { data: pagination } = await axios.get(props.organisationEventsUrl, {
                params: {
                    per_page: perPage,
                    page,
                    sort_by: sortBy || 'name',
                    order: order || 'asc',
                    search: search || '',
                },
            });

            const { data, ...rest } = pagination;

            setEvents(data);

            return rest; // Return the rest of the pagination data for use in the pagination component, if needed.
        } catch (error) {
            console.log(error);
        }
    };

    /**
     * Written optimistically so the switch moves at once, and put back if the
     * save is refused — the projects list is not refetched, which would cost a
     * full re-price of every row for one boolean.
     */
    const setRateCardEnabled = (event, enabled) => {
        setEvents((current) => current.map((row) => (row.id === event.id ? { ...row, rate_card_enabled: enabled } : row)));

        return axios
            .put(props.organisationEventRateCardUrl.replace('EVENT_SLUG', event.slug), { rate_card_enabled: enabled })
            .then(() => {
                toast.success(
                    enabled ? $t('Rate card switched on for {{name}}', { name: event.name }) : $t('Rate card switched off for {{name}}', { name: event.name }),
                );
            })
            .catch(() => {
                setEvents((current) => current.map((row) => (row.id === event.id ? { ...row, rate_card_enabled: !enabled } : row)));
                toast.error($t('Failed to change the rate card setting'));
            });
    };

    const setProjectClosed = (event, closed) => {
        setEvents((current) => current.map((row) => (row.id === event.id ? { ...row, is_closed: closed } : row)));

        return axios
            .put(props.organisationEventStatusUrl.replace('EVENT_SLUG', event.slug), { is_closed: closed })
            .then(() => {
                toast.success(closed ? $t('{{name}} marked as Closed', { name: event.name }) : $t('{{name}} marked as Active', { name: event.name }));
            })
            .catch(() => {
                setEvents((current) => current.map((row) => (row.id === event.id ? { ...row, is_closed: !closed } : row)));
                toast.error($t('Failed to change the project status'));
            });
    };

    const deleteEventBySlug = (eventSlug) => {
        return axios
            .delete(props.organisationEventsDeleteUrl.replace('EVENT_SLUG', eventSlug))
            .then(() => {
                toast.success($t('Event deleted successfully'));
            })
            .catch((error) => {
                toast.error($t('Failed to delete event'));

                console.log(error);
            });
    };

    return (
        <OrganisationEventsTable
            organisation={props.organisation}
            roles={props.roles}
            events={events}
            deleteEventBySlug={deleteEventBySlug}
            fetchEvents={fetchEvents}
            eventDashboardUrl={props.organisationEventDashboardUrl}
            organisationEventsCloneUrl={props.organisationEventsCloneUrl}
            organisationEventsCreateUrl={props.organisationEventsCreateUrl}
            canViewEventDetails={props.canViewEventDetails}
            setRateCardEnabled={setRateCardEnabled}
            setProjectClosed={setProjectClosed}
        />
    );
}
